module.exports = __webpack_public_path__ + "static/media/Link_Button.67445782.png";